<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />
    <!-- 점검정보  -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 점검정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>실시일</div>
          <p v-if="isPrint" class="print-input">{{ form.실시일 }}</p>
          <date-selector v-else v-model="form.실시일" :readonly="board.readonly" />
        </div>
        <div>
          <div>실시기관</div>
          <p v-if="isPrint" class="print-input">{{ form.실시기관 }}</p>
          <ml-input v-else v-model="form.실시기관" class="w-full" />
        </div>
        <div>
          <div>실시부서</div>
          <p v-if="isPrint" class="print-input">{{ form.실시부서 }}</p>
          <ml-input v-else v-model="form.실시부서" class="w-full" />
        </div>
        <div>
          <div>특이사항</div>
          <p v-if="isPrint" class="print-input">{{ form.특이사항 }}</p>
          <ml-input v-else v-model="form.특이사항" class="w-full" />
        </div>
      </div>
    </div>

    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="청력보존프로그램평가표"
      table-header-title="점검항목"
      :table-header-note="[{ text: '비고', width: '389' }]"
      contentBefore="numbering"
      v-model="form.inspectList"
      class="mt-28px"
    />

    <!--   사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import * as inspectData from "./inspectData";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    TableInspectMerge,
    FileUploadModule,
    TableInspect,
    FieldSelectModule,
    PhotoUploadGridModule,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],
        inspectList: JSON.parse(JSON.stringify(inspectData.inspectTable)),
        실시일: "",
        실시기관: "",
        실시부서: "",
        특이사항: "",
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {},
};
</script>
